//# sourceMappingURL=modal.mjs.map
/// <reference types="./modal.d.mts" />
import * as $redraw from "../../../redraw/redraw.mjs";
import * as $a from "../../../redraw_dom/redraw/dom/attribute.mjs";
import * as $css from "../../../sketch/sketch/css.mjs";
import * as $length from "../../../sketch/sketch/css/length.mjs";
import { px } from "../../../sketch/sketch/css/length.mjs";
import * as $h from "../../../sketch_redraw/sketch/redraw/dom/html.mjs";
import * as $colors from "../../ds/colors.mjs";
import * as $shadows from "../../ds/css/shadows.mjs";
import * as $modal from "../../ds/providers/modal.mjs";
import * as $display from "../../ds/typography/display.mjs";
import * as $text from "../../ds/typography/text.mjs";
import { toList } from "../../gleam.mjs";

export const use_modal = $modal.use_modal;

export function modal(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.position("absolute"),
      $css.z_index(100_000_000),
      $css.top(px(0)),
      $css.bottom(px(0)),
      $css.right(px(0)),
      $css.left(px(0)),
      $css.property("backdrop-filter", "blur(4px)"),
      $css.background("rgba(255, 255, 255, 0.1)"),
      $css.display("flex"),
      $css.align_items("center"),
      $css.justify_content("center"),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function large() {
  return $a.attribute("data-size", "large");
}

export function body(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.position("absolute"),
      $css.compose($text.md($text.regular)),
      $css.display("flex"),
      $css.flex_direction("column"),
      $css.max_width_("90vw"),
      $css.max_height_("90vh"),
      $css.background($colors.light.text_white),
      $css.padding(px(48)),
      $css.border_radius(px(10)),
      $css.width(px(450)),
      $css.box_shadow($shadows.m()),
      $css.gap(px(48)),
      $css.border("1px solid " + $colors.light.grey_400),
      $css.overflow("auto"),
      $css.selector("[data-size=\"large\"]", toList([$css.width(px(650))])),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function title(attrs, children) {
  let _pipe = $css.class$(
    toList([$css.compose($display.md()), $css.overflow_wrap("break-word")]),
  );
  return $h.div(_pipe, attrs, children);
}

export function explanations(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.compose($text.md($text.regular)),
      $css.color($colors.light.text_body),
      $css.overflow_wrap("break-word"),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function actions(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.compose($text.md($text.regular)),
      $css.display("flex"),
      $css.gap(px(10)),
      $css.justify_content("end"),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}
